import React from 'react';
import ImageList from './ImageList';
import WrapComponent from '../WrapComponent';
import './ImageList.less';

class ImageIndex extends React.Component{
    render(){
        let props = this.props;
        const {getFieldProps} = props.form;
        let fieldProps = getFieldProps(props.api_name, {
            validate: [{
                trigger: 'onChange',
                rules: [{
                    required: props.is_required,
                    message: $st(`paas.smart.form.isrequired`)
                }]
            }]
        })

        return (
            <div>
                <ImageList {...props} {...fieldProps}></ImageList>
                {props.errorText&&<div className="input-error">{props.errorText}</div>}
            </div>
        )
    }
    
}

export default WrapComponent(ImageIndex);


// WEBPACK FOOTER //
// ./src/component/Image/index.js